import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import type { RootState } from '/business/shared/state/store';

type CommuterFactorCanonicalNameProps = {
  commuterFactor?: string | null;
};

export function CommuterFactorCanonicalName({ commuterFactor = null }: CommuterFactorCanonicalNameProps) {
  const commuterFactors = useSelector((state: RootState) => state.emissionTypes?.data?.commuterFactors) || null;
  const { t } = useTranslation();
  if (!commuterFactors || !Array.isArray(commuterFactors) || commuterFactors.length <= 0) {
    return (
      // @i18n: Commuter factors not loaded
      <Trans i18nKey="business:SiteComponents.commuterFactors.failureToLoadError" />
    );
  }
  const foundCommuterFactor = commuterFactors.find(({ name }) => name === commuterFactor);
  if (!foundCommuterFactor) {
    return (
      // @i18n: Cannot find commuter factor
      <Trans i18nKey="business:SiteComponents.commuterFactors.failureToFindError" />
    );
  }

  const translitDisplay = t(
    `business:emissionFactors.transportModes.${foundCommuterFactor.displayName}`,
    foundCommuterFactor.displayName,
  );
  return <>{translitDisplay}</>;
}

export default CommuterFactorCanonicalName;
